import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { IconStarCircleFilled } from '@noths/polaris-client-ribbons-design-system';

import { PartnerBadge } from 'src/components/atoms/PartnerBadge/PartnerBadge';
import * as styles from './PartnerMiniModule.styles';

export const PARTNER_RATING_TEST_ID = 'PartnerMiniModule-partner-rating-test-id';

interface PartnerMiniModuleProps {
  isTopBrand?: boolean;
  linkHref: string;
  location: string;
  logoSrc: string;
  name: string;
  onLinkClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onVisible?: () => void;
  partnerRating?: number;
  partnerReviewCount?: number;
}

export const PartnerMiniModule = ({
  isTopBrand = false,
  linkHref,
  location,
  logoSrc,
  name,
  onLinkClick,
  onVisible,
  partnerRating,
  partnerReviewCount,
}: PartnerMiniModuleProps) => {
  const brandReviewsText = partnerReviewCount
    ? `(${partnerReviewCount.toLocaleString()} Brand reviews)`
    : '';
  const rootRef = useImpressionRef<HTMLDivElement>(() => onVisible?.());

  return (
    <div css={styles.root} ref={rootRef}>
      {isTopBrand && (
        <div css={styles.topBrandHeader}>
          <PartnerBadge />
        </div>
      )}
      <div css={styles.body}>
        <img alt="" src={logoSrc} />
        <ul>
          <li>
            Sold by{' '}
            <strong>
              <a href={linkHref} onClick={onLinkClick}>
                {name}
              </a>
            </strong>
          </li>
          <li>
            From <strong>{location}</strong>
          </li>
          {partnerRating && (
            <li data-testid={PARTNER_RATING_TEST_ID}>
              <IconStarCircleFilled color="var(--brand-purple-base)" height={16} width={16} />
              <strong>{partnerRating}/5</strong> {brandReviewsText}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};
